import React, { useEffect, useRef, useState } from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/g6GHjb5UkdVuBNWsq6UHVc/Marca_con_fondo_transparente-removebg-preview.png';
const SHOW_CTA_SECTIONS = [1, 2, 4];
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showCta, setShowCta] = useState(false);
  const navRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
      const navHeight = navRef.current?.offsetHeight ?? 0;
      // Probe the middle of the visible area below the navbar to find the
      // predominant section.
      const probeY = navHeight + (window.innerHeight - navHeight) / 2;
      const sections = Array.from(document.querySelectorAll<HTMLElement>('main > section'));
      const activeIndex = sections.findIndex(section => {
        const rect = section.getBoundingClientRect();
        return rect.top <= probeY && rect.bottom > probeY;
      });
      // Section order: 0 Hero, 1 Problem, 2 Phases, 3 Pricing, 4 FAQ, 5 Final CTA.
      // Footer (outside main) resolves to -1 and stays hidden.
      setShowCta(SHOW_CTA_SECTIONS.includes(activeIndex));
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);
  return <nav ref={navRef} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-cream shadow-md py-3' : 'bg-brand-cream py-5'}`} data-id="element-88" data-mp="10fdfnrl0l3iu">
      <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-89" data-mp="1a6htgnyyeic3">
        <img src={LOGO_URL} alt="El Código del Bienestar" style={{
        width: '182px',
        height: 'auto'
      }} className="object-contain" data-id="element-90" data-mp="1f5ui9e9dxzhb" />
        <div aria-hidden={!showCta} className={`transition-[opacity,transform,visibility] duration-[250ms] ease-[cubic-bezier(0.23,1,0.32,1)] motion-reduce:transition-none ${showCta ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-1 invisible pointer-events-none'}`} data-id="element-91" data-mp="uh1w7kcmiof3">
          <button tabIndex={showCta ? 0 : -1} onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-brand-terracotta text-white px-6 py-2.5 rounded-full font-medium hover:bg-opacity-90 hover:scale-105 transition-all duration-300 shadow-sm" data-id="element-92" data-mp="zdin2mb7jgvv">
            QUIERO EMPEZAR MIS 21 DÍAS →
          </button>
        </div>
      </div>
    </nav>;
}